<template>
  <div>
    <div class="file-box">
      <Upload
        v-if="!isDownloadFileBtn"
        :before-upload="beforeUpload"
        :show-upload-list="false"
        action="/"
      >
        <Button size="small" type="primary">上传附件</Button>
      </Upload>
      <input
        type="file"
        ref="fileInput"
        style="display: none"
        @change="handleFileChange"
      />
      <div>
        <div v-if="uploaadLoding" style="display: flex; margin-left: 20px">
          <Spin size="large" />
          <Spin size="large" />
          <Spin size="large" />
        </div>
        <div
          v-for="file in files"
          :key="file.name || file.filename || file.path"
          class="file-item"
        >
          <span
            @click="openFile(file)"
            style="margin-left: 20px; color: #5cadff; cursor: pointer"
          >
            {{ file.name || file.filename }}
          </span>
          <Button
            v-if="isDownloadFileBtn && canInlinePreview(file)"
            style="margin-left: 10px"
            size="small"
            @click="openFile(file)"
          >
            预览
          </Button>
          <Button
            style="margin-left: 20px"
            size="small"
            type="primary"
            @click="downloadFile(file)"
            v-if="isDownloadFileBtn"
          >
            下载
          </Button>
          <Button
            v-if="!isDownloadFileBtn"
            style="margin-left: 10px"
            size="small"
            type="error"
            @click="removeFile(file)"
          >
            删除
          </Button>
          <!-- <Button
            style="margin-left: 10px"
            size="small"
            type="warning"
            @click="startReuploadFile(file)"
            v-if="isRestBtn"
          >
            重新上传
          </Button> -->
        </div>
      </div>
      <!-- 预览弹窗（PDF / 图片走内嵌预览，避免仅相对路径在新窗口打开失败） -->
      <Modal
        title="预览"
        v-model="modalShow"
        draggable
        :fullscreen="true"
        @on-visible-change="onPreviewVisibleChange"
      >
        <iframe
          v-if="previewType === 'pdf' && previewUrl"
          :src="previewUrl"
          style="width: 100%; height: 80vh; border: 0"
          title="pdf-preview"
        />
        <div
          v-else-if="previewType === 'image' && previewUrl"
          style="text-align: center; max-height: 80vh; overflow: auto"
        >
          <img
            :src="previewUrl"
            alt="preview"
            style="max-width: 100%; max-height: 80vh; object-fit: contain"
          />
        </div>
        <div v-else style="padding: 24px; color: #999">
          暂不支持该格式在线预览，请下载后查看
        </div>
        <div slot="footer"></div>
      </Modal>
    </div>
    <div v-if="!isDownloadFileBtn" style="margin-top: 10px; color: #6ea0ff">
      单次可上传附件大小不超过50M
    </div>
  </div>
</template>

<script>
import { postData } from './api';
import { saveAs } from 'file-saver';
import LuckyExcel from 'luckyexcel';
export default {
  props: {
    initialFiles: {
      type: null,
      default: () => [],
    },
    id: {
      type: null,
      default: '',
    },
    source: {
      type: null,
      default: '',
    },
    isDownloadFileBtn: {
      type: null,
      default: false,
    },
    isRestBtn: {
      type: null,
      default: false,
    },
    isQuery: {
      type: null,
      default: true,
    },
  },
  components: {},
  data() {
    return {
      uploaadLoding: false,
      filetype: '',
      filepath: '',
      previewType: '',
      previewUrl: '',
      modalShow: false,
      files: [...this.initialFiles],
      reuploadingFile: null,
      oldFile: '',
    };
  },
  methods: {
    fullFileUrl(path) {
      if (!path) return '';
      if (/^https?:\/\//i.test(path)) return path;
      const base = process.env.VUE_APP_BASE_API || '';
      const p = path.startsWith('/') ? path : `/${path}`;
      return `${base}${p}`;
    },
    canInlinePreview(file) {
      const path = file && file.path;
      if (!path) return false;
      const ext = this.getFileExtension(path).toLowerCase();
      const images = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'];
      return ext === 'pdf' || images.includes(ext);
    },
    onPreviewVisibleChange(visible) {
      if (!visible) {
        this.previewType = '';
        this.previewUrl = '';
      }
    },
    tryOpenPreviewModal(fullUrl, ext) {
      const e = (ext || '').toLowerCase();
      const images = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'];
      if (e === 'pdf') {
        this.previewType = 'pdf';
        this.previewUrl = fullUrl;
        this.modalShow = true;
        return true;
      }
      if (images.includes(e)) {
        this.previewType = 'image';
        this.previewUrl = fullUrl;
        this.modalShow = true;
        return true;
      }
      return false;
    },
    //打开文件
    openFile(item) {
      const rawPath = item.path;
      const fullUrl = this.fullFileUrl(rawPath);
      const fileExtension = this.getFileExtension(
        rawPath || item.name || '',
      ).toLowerCase();
      if (fullUrl && this.tryOpenPreviewModal(fullUrl, fileExtension)) {
        return;
      }
      switch (fileExtension) {
        case 'docx':
          this.filetype = 'docx';
          break;
        case 'doc':
          this.filetype = 'doc';
          break;
        case 'pdf':
          this.filetype = 'pdf';
          break;
        case 'xls':
          this.filetype = 'xls';
          break;
        case 'xlsx':
          this.filetype = 'xlsx';
          break;
        default:
          this.filetype = null;
      }
      if (this.filetype != null && this.filetype != 'pdf') {
        if (this.filetype === 'docx') {
          window.open(
            fullUrl.replace(/\.docx?$/i, '.pdf'),
            item.name || item.filename,
          );
        } else if (this.filetype === 'doc') {
          window.open(
            fullUrl.replace(/\.doc?$/i, '.pdf'),
            item.name || item.filename,
          );
        } else if (this.filetype == 'xls' || this.filetype == 'xlsx') {
          this.loadExcelFile(rawPath, item.name || item.filename);
        } else {
          window.open(
            'https://view.officeapps.live.com/op/view.aspx?src=' +
              encodeURIComponent(fullUrl),
          );
        }
      } else if (fullUrl) {
        window.open(fullUrl);
      }
    },
    async loadExcelFile(filePath, fileName) {
      const fileUrl = this.fullFileUrl(filePath);
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const file = new File([blob], fileName, { type: blob.type });
      LuckyExcel.transformExcelToLucky(file, (exportJson) => {
        if (!exportJson.sheets || exportJson.sheets.length === 0) {
          return this.$message.warning('当前格式不支持,请下载本地查看');
        }
        // 创建预览内容
        this.initExcel(exportJson, '名称');
      });
    },
    initExcel(exportJson = {}, FileName) {
      window.luckysheet.destroy();
      window.luckysheet.create({
        container: 'luckysheet', // luckysheet为容器id
        lang: 'zh', // 默认语言
        title: FileName,
        //

        allowEdit: false, // 是否允许前台编辑
        sheetFormulaBar: false, // 是否显示公式栏
        enableAddRow: false, // 是否允许添加行
        showsheetbar: true, // 是否显示底部sheet页按钮
        showtoolbar: false, // 是否显示工具栏
        showinfobar: false, // 是否显示顶部信息栏

        data: exportJson.sheets, // excel数据
        userInfo: exportJson.info.name.creator,
      });
      this.luckysheelShow = true;
    },
    getFileExtension(url) {
      try {
        return url.split('.').pop();
      } catch (error) {
        return '';
      }
    },
    //查询文件
    async getFileList() {
      let res = await postData(
        '/admin/FileRecordUniversal/GetFileList',
        {
          dataentrystrid: this.id,
          source: this.source,
        },
        '查询任务主数据',
      );
      if (res.data.success) {
        console.log(res.data.data, '文件帆帆帆帆');
        this.files = res.data.data.map((item) => {
          let newItem = { ...item };
          newItem.name = newItem.filename;
          delete newItem.filename;
          return newItem;
        });
        this.uploaadLoding = false;
      } else {
        console.log('上传附件');
        this.uploaadLoding = false;
        this.$message.error(res.data.msg);
      }
      this.uploaadLoding = false;
    },
    beforeUpload(file) {
      const maxSizeInMB = 50; // 设置文件大小限制为2MB
      if (file.size / 1024 / 1024 > maxSizeInMB) {
        this.$message.error(`文件大小不能超过${maxSizeInMB}MB！`);
        return false;
      }
      this.convertFileToBase64(file, (base64) => {
        const fileData = { name: file.name, base64: base64 };
        this.files.push(fileData);
        this.$emit('upload-success', fileData);
        this.uploadFileToServer(fileData); // 调用上传接口
      });
      return false; // 阻止默认上传行为
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file && this.reuploadingFile) {
        this.convertFileToBase64(file, (base64) => {
          this.reuploadingFile.base64 = base64;
          this.reuploadingFile.name = file.name;
          this.reuploadFileToServer(this.reuploadingFile); // 调用重新上传接口
          this.$emit('reupload-success', this.reuploadingFile); // 发送重新上传成功事件
          this.reuploadingFile = null;
        });
      }
    },
    async downloadFile(file) {
      const baseApi = process.env.VUE_APP_BASE_API;
      let fileUrl = `${baseApi}${file.path}`;
      let response, blob;

      if (file.base64str) {
        // 如果文件是Base64编码的
        const base64Response = await fetch(
          `data:${file.mimeType};base64,${file.base64Data}`,
        );
        blob = await base64Response.blob();
      } else {
        // 常规文件下载
        response = await fetch(fileUrl);
        blob = await response.blob();
      }
      saveAs(blob, file.filename || file.name);
    },
    async removeFile(file) {
      if (file.fileid) {
        this.uploaadLoding = true;
        let res = await postData(
          '/admin/FileRecordUniversal/DeleteFile',
          file,
          '查询任务主数据',
        );
        if (res.data.success) {
          if (this.isQuery) {
            this.getFileList();
            return;
          }
          this.uploaadLoding = false;
        } else {
          this.$message.error(res.data.msg);
        }
      } else {
        this.files = this.files.filter((f) => f.name !== file.name);
      }
      this.$emit('file-removed', file);
    },
    convertFileToBase64(file, callback) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64 = reader.result.split(',')[1]; // 移除 Data URL 部分
        // const base64 = reader.result; // 移除 Data URL 部分
        callback(base64);
      };
      reader.onerror = (error) => {
        console.log('Error converting file to Base64:', error);
        this.$emit('upload-error', error);
      };
    },
    startReuploadFile(file) {
      const maxSizeInMB = 100; // 设置文件大小限制为2MB
      if (file.size / 1024 / 1024 > maxSizeInMB) {
        this.$message.error(`文件大小不能超过${maxSizeInMB}MB！`);
        return false;
      }
      this.reuploadingFile = file;
      this.oldFile = file;
      this.$emit('start-reupload', file); // 发送开始重新上传事件
      this.$refs.fileInput.click(); // 触发文件输入点击
    },
    async uploadFileToServer(fileData) {
      if (this.isDownloadFileBtn) {
        this.uploaadLoding = true;
        // 实现上传接口调用
        console.log('上传文件到服务器:', fileData);
        let uploadedFiles = {};
        this.$set(uploadedFiles, fileData.name, fileData.base64);
        let res = await postData(
          '/admin/FileRecordUniversal/Upload',
          {
            dataentrystrid: this.id,
            newfile: uploadedFiles,
            source: this.source,
          },
          '查询任务主数据',
        );
        if (res.data.success) {
          this.getFileList();
        } else {
          this.$message.error(res.data.msg);
        }
        // 示例：axios.post('/api/upload', fileData);
      }
    },
    async reuploadFileToServer(fileData) {
      this.uploaadLoding = true;
      let uploadedFiles = {};
      this.$set(uploadedFiles, fileData.name, fileData.base64);
      this.oldFile.newfile = uploadedFiles;
      // 实现重新上传接口调用
      console.log('重新上传文件到服务器:', fileData);
      // 示例：axios.post('/api/reupload', fileData);
      let res = await postData(
        '/admin/FileRecordUniversal/Reupload',
        this.oldFile,
        '查询任务主数据',
      );
      if (res.data.success) {
        this.getFileList();
      } else {
        this.$message.error(res.data.msg);
      }
    },
  },
  watch: {
    initialFiles(newFiles) {
      this.files = [...newFiles];
      console.log(this.files, '监听的文件');
    },
  },
};
</script>

<style scoped>
.file-box {
  display: flex;
}
.file-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.file-item span {
  flex: 1;
}
</style>
